export default {"src":"https://webcdn.trailways.ca/_next/static/media/group-3.7aad290c.svg","height":3,"width":8,"blurWidth":0,"blurHeight":0};